import { render, staticRenderFns } from "./dialogProtTest.vue?vue&type=template&id=5a85f587&"
import script from "./dialogProtTest.vue?vue&type=script&lang=js&"
export * from "./dialogProtTest.vue?vue&type=script&lang=js&"
import style0 from "./dialogProtTest.vue?vue&type=style&index=0&id=5a85f587&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports